module.exports = __webpack_public_path__ + "img/holidayinn.de662b10.jpg";